import { Button } from '@ria-client/tw-shadcn/components/button';

const DEFAULT_MESSAGE = 'Something went wrong. Please try again.';

export type ErrorStateProps = {
  message?: string;
  onRetry: () => void;
};

export function ErrorState({ message = DEFAULT_MESSAGE, onRetry }: ErrorStateProps) {
  return (
    <div className="px-6 py-12 text-center md:py-16">
      <div
        role="alert"
        className="mx-auto mb-6 max-w-[480px] rounded-card border border-[var(--content-red-lighter)] bg-card p-6"
      >
        <span className="typography-text-bold mb-2 block text-destructive">Search failed</span>
        <p className="typography-text-small text-muted-foreground">{message}</p>
      </div>
      <Button
        type="button"
        onClick={onRetry}
        variant="outline"
        fullWidth={false}
        className="rounded-full border-primary px-5 py-1.5 font-semibold text-primary"
      >
        Retry
      </Button>
    </div>
  );
}
